import { useState } from "react";
import TablePicker from "./TablePicker";

const Toolbar = ({ editor, onContentLinkClick, onImageLinkClick }) => {
    const [showTablePicker, setShowTablePicker] = useState(false);

    if (!editor) return null;

    const Icon = ({ name }) => {
        const svgProps = {
            width: "18",
            height: "18",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        };

        switch (name) {
            case "accordion": return <svg {...svgProps}><rect x="3" y="4" width="18" height="3" rx="1" ry="1" /><rect x="3" y="10" width="18" height="3" rx="1" ry="1" /><rect x="3" y="16" width="18" height="3" rx="1" ry="1" /></svg>;
            case "bold": return <svg {...svgProps}><path d="M6 12h9a4 4 0 0 1 0 8H6v-8zm0 0V4h7a4 4 0 0 1 0 8H6z" /></svg>;
            case "italic": return <svg {...svgProps}><line x1="19" y1="4" x2="10" y2="4" /><line x1="14" y1="20" x2="5" y2="20" /><line x1="15" y1="4" x2="9" y2="20" /></svg>;
            case "underline": return <svg {...svgProps}><path d="M6 3v7a6 6 0 0 0 12 0V3" /><line x1="4" y1="21" x2="20" y2="21" /></svg>;
            case "link": return <svg {...svgProps}><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></svg>;
            case "unlink": return <svg {...svgProps}><path d="m18.84 5.16-3.12 3.12" /><path d="m5.16 18.84 3.12-3.12" /><path d="M10 13a5 5 0 0 0 1.54.54" /><path d="M14 11a5 5 0 0 0-1.54-.54" /><path d="M15.13 3.29c-.73-.2-1.49-.3-2.26-.3-3.16 0-6 2.54-6 6 0 .77.1 1.53.3 2.26" /><path d="M8.87 20.71c.73.2 1.49.3 2.26.3 3.16 0 6-2.54 6-6 0-.77-.1-1.53-.3-2.26" /></svg>;
            case "image": return <svg {...svgProps}><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21 15 16 10 5 21" /></svg>;
            case "list-ul": return <svg {...svgProps}><line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" /></svg>;
            case "list-ol": return <svg {...svgProps}><line x1="10" y1="6" x2="21" y2="6" /><line x1="10" y1="12" x2="21" y2="12" /><line x1="10" y1="18" x2="21" y2="18" /><path d="M4 6h1v4" /><path d="M4 10h2" /><path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1" /></svg>;
            case "table": return <svg {...svgProps}><path d="M3 3h18v18H3zM3 9h18M3 15h18M9 3v18M15 3v18" /></svg>;
            case "content-link": return <svg {...svgProps}><path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3" /><line x1="8" y1="12" x2="16" y2="12" /></svg>;
            case "list-A": return <svg {...svgProps}><line x1="10" y1="6" x2="21" y2="6" /><line x1="10" y1="12" x2="21" y2="12" /><line x1="10" y1="18" x2="21" y2="18" /><text x="0" y="15" fontSize="11" fill="currentColor" fontWeight="900" style={{ fontFamily: "serif" }}>A</text></svg>;
            case "list-a": return <svg {...svgProps}><line x1="10" y1="6" x2="21" y2="6" /><line x1="10" y1="12" x2="21" y2="12" /><line x1="10" y1="18" x2="21" y2="18" /><text x="0" y="15" fontSize="11" fill="currentColor" fontWeight="900" style={{ fontFamily: "serif" }}>a</text></svg>;
            case "list-I": return <svg {...svgProps}><line x1="10" y1="6" x2="21" y2="6" /><line x1="10" y1="12" x2="21" y2="12" /><line x1="10" y1="18" x2="21" y2="18" /><text x="0" y="15" fontSize="11" fill="currentColor" fontWeight="900" style={{ fontFamily: "serif" }}>I</text></svg>;
            case "list-i": return <svg {...svgProps}><line x1="10" y1="6" x2="21" y2="6" /><line x1="10" y1="12" x2="21" y2="12" /><line x1="10" y1="18" x2="21" y2="18" /><text x="0" y="15" fontSize="11" fill="currentColor" fontWeight="900" style={{ fontFamily: "serif" }}>i</text></svg>;
            case "unlink-image": return <svg {...svgProps}><path d="M11 20l4-1a5 5 0 0 0 4.54-4.54l1-4" /><path d="m15 13-5-5" /><path d="m2 2 20 20" /><path d="M18.4 4.07a5.07 5.07 0 0 0-5.41.73l-4.58 4.58a5.07 5.07 0 0 0-.77 5.41" /><path d="m5 11-1 4a5 5 0 0 0 4.54 4.54l4-1" /></svg>;
            default: return null;
        }
    };

    return (
        <div className="toolbar">
            {/* GROUP 1: INLINE */}
            <div className="toolbar-group">
                <button
                    className={`btn btn-ghost`}
                    onClick={() => editor.chain().focus().toggleBold().run()}
                    title="Bold"
                >
                    <Icon name="bold" />
                </button>
                <button
                    className={`btn btn-ghost`}
                    onClick={() => editor.chain().focus().toggleItalic().run()}
                    title="Italic"
                >
                    <Icon name="italic" />
                </button>
                <button
                    className={`btn btn-ghost`}
                    onClick={() => editor.chain().focus().toggleUnderline().run()}
                    title="Underline"
                >
                    <Icon name="underline" />
                </button>
            </div>

            {/* GROUP: ACCORDION */}
            <div className="toolbar-group">
                <button
                    className={`btn btn-ghost`}
                    onClick={() => {
                        editor.chain().focus().insertContent({
                            type: "accordion",
                            content: [
                                {
                                    type: "accordionItem",
                                    content: [
                                        { type: "accordionTitle", content: [{ type: "paragraph", content: [{ type: "text", text: "Accordion Title" }] }] },
                                        { type: "accordionContent", attrs: { open: true }, content: [{ type: "paragraph", content: [{ type: "text", text: "Accordion Description" }] }] }
                                    ]
                                }
                            ]
                        }).run();
                    }}
                    title="Insert Accordion"
                >
                    <Icon name="accordion" />
                </button>
            </div>

            {/* GROUP 2: HEADINGS */}
            <div className="toolbar-group">
                {[1, 2, 3, 4, 5, 6].map(level => (
                    <button
                        key={level}
                        className={`btn btn-ghost`}
                        onClick={() => editor.chain().focus().toggleHeading({ level }).run()}
                        title={`Heading ${level}`}
                    >
                        H{level}
                    </button>
                ))}
            </div>

            {/* GROUP 3: LISTS */}
            <div className="toolbar-group">
                <button
                    className={`btn btn-ghost`}
                    onClick={() => editor.chain().focus().toggleBulletList().run()}
                    title="Bullet List"
                >
                    <Icon name="list-ul" />
                </button>
                <button
                    className={`btn btn-ghost`}
                    onClick={() => editor.chain().focus().setListType("1").run()}
                    title="Numbered List (1, 2, 3)"
                >
                    <Icon name="list-ol" />
                </button>
                <button
                    className={`btn btn-ghost`}
                    onClick={() => editor.chain().focus().setListType("A").run()}
                    title="Alphabetical Upper (A, B, C)"
                >
                    <Icon name="list-A" />
                </button>
                <button
                    className={`btn btn-ghost`}
                    onClick={() => editor.chain().focus().setListType("a").run()}
                    title="Alphabetical Lower (a, b, c)"
                >
                    <Icon name="list-a" />
                </button>
                <button
                    className={`btn btn-ghost`}
                    onClick={() => editor.chain().focus().setListType("I").run()}
                    title="Roman Upper (I, II, III)"
                >
                    <Icon name="list-I" />
                </button>
                <button
                    className={`btn btn-ghost`}
                    onClick={() => editor.chain().focus().setListType("i").run()}
                    title="Roman Lower (i, ii, iii)"
                >
                    <Icon name="list-i" />
                </button>
            </div>

            {/* GROUP 6: TABLES */}
            <div className="toolbar-group">
                <div style={{ position: "relative", display: "inline-block" }}>
                    <button
                        className={`btn btn-ghost`}
                        onClick={() => setShowTablePicker(prev => !prev)}
                        title="Insert Table"
                    >
                        <Icon name="table" />
                    </button>

                    {showTablePicker && (
                        <div style={{ position: "absolute", top: "100%", left: 0, zIndex: 100 }}>
                            <TablePicker
                                onSelect={(rows, cols) => {
                                    editor.chain().focus().insertTable({ rows, cols, withHeaderRow: false }).run();
                                    setShowTablePicker(false);
                                }}
                            />
                        </div>
                    )}
                </div>
            </div>

            {/* GROUP 4: MEDIA & LINKS */}
            <div className="toolbar-group">
                <button
                    className={`btn btn-ghost`}
                    onClick={() => {
                        const previousUrl = editor.getAttributes("link").href;
                        const url = prompt("Enter URL", previousUrl || "");
                        if (url === null) return;
                        if (url === "") {
                            editor.chain().focus().extendMarkRange("link").unsetLink().run();
                            return;
                        }
                        editor.chain().focus().extendMarkRange("link").setLink({ href: url }).run();
                    }}
                    title="Insert Link"
                >
                    <Icon name="link" />
                </button>
                <button
                    className="btn btn-ghost"
                    onClick={() => {
                        editor
                            .chain()
                            .focus()
                            .extendMarkRange("link")
                            .unsetLink()
                            .unsetUnderline()
                            .run();
                    }}
                    title="Remove Link"
                >
                    <Icon name="unlink" />
                </button>
                <button
                    className="btn btn-ghost"
                    onClick={() => editor.chain().focus().insertContent({ type: "imageBlock" }).run()}
                    title="Insert Image Block"
                >
                    <Icon name="image" />
                </button>
            </div>

            {/* GROUP 5: CUSTOM LINKS */}
            <div className="toolbar-group">
                <button
                    className={`btn btn-ghost`}
                    onClick={onContentLinkClick}
                    title="Link to Other Content"
                >
                    Add Content Link
                </button>
                <button
                    className="btn btn-ghost"
                    onClick={() => {
                        editor
                            .chain()
                            .focus()
                            .extendMarkRange("contentLink")
                            .unsetContentLink()
                            .run();
                    }}
                    title="Remove Content Link"
                >
                    Remove Content Link
                </button>

            </div>

            <div className="toolbar-group">
                <button
                    className={`btn btn-ghost`}
                    onClick={onImageLinkClick}
                    title="Link to Image Metadata"
                >
                    Link Image
                </button>
                <button
                    className="btn btn-ghost"
                    onClick={() => editor.chain().focus().unsetImageLink().run()}
                    title="Unlink Image Metadata"
                >
                    <Icon name="unlink-image" />
                    Unlink Image
                </button>
            </div>
        </div>
    );
};

export default Toolbar;